<template>
    <TextButton title="Project NICE" link="/nice" id="tiptel-subnavigationTitle" />
</template>

<script lang="ts" setup>
    import TextButton from '@/components/Buttons/TextButton.vue'
</script>
